export default __webpack_public_path__ + "static/media/TnB0445.1fd293ed.jpg";